// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-container[data-v-83a4125a] .el-drawer__header {\n  margin-bottom: 10px;\n  border-bottom: 1px solid #cccccc;\n  padding-bottom: 20px;\n  color: black;\n}\n.app-container[data-v-83a4125a] .el-table__expand-icon {\n  width: 12px !important;\n}\n.postcodeType-class[data-v-83a4125a]  .el-input__inner {\n  font-size: 13px;\n  font-weight: bold;\n  border: none;\n  padding: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
